import { axiosPost } from '../AxiosApi';
import { sendRequest } from '../AxiosRequest';

export const readBetGameSettingList = async () => {
  const payload = {
    apiUrl: process.env.REACT_APP_MINIGAME_URL,
    path: '/game-setting/list',
  };
  return await sendRequest(payload, 'readBetGameSettingList', axiosPost);
};

export const readBetGameSettingDetail = async (gameSettingId: string) => {
  const payload = {
    apiUrl: process.env.REACT_APP_MINIGAME_URL,
    path: '/game-setting/detail',
    body: {
      gameSettingId,
    },
  };
  return await sendRequest(payload, 'readBetGameSettingDetail', axiosPost);
};
export const readBetGameDashboard = async () => {
  const payload = {
    apiUrl: process.env.REACT_APP_MINIGAME_URL,
    path: '/admin-dashboard/combine',
  };
  return await sendRequest(payload, 'readBetGameDashboard', axiosPost);
};

export const readBetUserLedgerList = async (address: string) => {
  const payload = {
    apiUrl: process.env.REACT_APP_MINIGAME_URL,
    path: '/admins/ledger-list',
    body: {
      address,
    },
  };
  return await sendRequest(payload, 'readBetUserLedgerList', axiosPost);
};

export const readJackpotList = async () => {
  const payload = {
    apiUrl: process.env.REACT_APP_MINIGAME_URL,
    path: '/admin-bet/jackpot-list',
  };
  return await sendRequest(payload, 'readJackpotList', axiosPost);
};

export const readJackpotAmount = async () => {
  const payload = {
    apiUrl: process.env.REACT_APP_MINIGAME_URL,
    path: '/v1/bet/total-jackpot',
  };
  return await sendRequest(payload, 'readJackpotAmount', axiosPost);
};

export const readNameType = async () => {
  const payload = {
    apiUrl: process.env.REACT_APP_MINIGAME_URL,
    path: '/game-setting/name-type',
  };
  return await sendRequest(payload, 'readNameType', axiosPost);
};

export const readSwapList = async () => {
  const payload = {
    apiUrl: process.env.REACT_APP_MINIGAME_URL,
    path: '/admins/swap-list',
  };
  return await sendRequest(payload, 'readSwapList', axiosPost);
};

export const readSmallWinSetting = async (gameSettingId: string) => {
  const payload = {
    apiUrl: process.env.REACT_APP_MINIGAME_URL,
    path: '/game-setting/small-setting-list',
    body: {
      gameSettingId,
    },
  };
  return await sendRequest(payload, 'readSmallWinSetting', axiosPost);
};

export const readCommonSettingList = async () => {
  const payload = {
    apiUrl: process.env.REACT_APP_MINIGAME_URL,
    path: '/game-setting/config-list',
  };
  return await sendRequest(payload, 'readCommonSettingList', axiosPost);
};

export const readJackpotSettingList = async () => {
  const payload = {
    apiUrl: process.env.REACT_APP_MINIGAME_URL,
    path: '/game-setting/jackpot-list',
  };
  return await sendRequest(payload, 'readJackpotSettingList', axiosPost);
};

export const readJackpotWalletList = async () => {
  const payload = {
    apiUrl: process.env.REACT_APP_MINIGAME_URL,
    path: '/admin-bet/jackpot-rank-list',
  };
  return await sendRequest(payload, 'readJackpotWalletList', axiosPost);
};

export const readWinHistoryList = async () => {
  const payload = {
    apiUrl: process.env.REACT_APP_MINIGAME_URL,
    path: '/admins/win-history-list',
  };
  return await sendRequest(payload, 'readWinHistoryList', axiosPost);
};
